import { memo } from 'react';
import { clsx } from 'clsx';
import { FormattedMessage } from 'react-intl';
import { HStack, Paragraph } from '@library';
import type { ProductCustomerPrice } from '../../../../product/types';
import styles from './ProductDiscountsBoxView.module.scss';

const isDiscountApplicable = (discountPercentage?: number) =>
    Math.abs(discountPercentage || 0) > 0;

const ProductDiscountsBoxView = ({
    customerPrice,
}: {
    customerPrice: ProductCustomerPrice;
}) => {
    const dealerDiscountPercentage =
        customerPrice.dealerDiscountPercentage || 0;
    const additionalDiscountPercentage =
        customerPrice.additionalDiscountPercentage || 0;

    const { appliedDiscountRule } = customerPrice;

    if (appliedDiscountRule) {
        return (
            <div
                className={clsx(
                    styles.hostettlerProductDiscountPill,
                    styles.preorderDiscountPercentage
                )}
            >
                <HStack align="center" justify="center">
                    <Paragraph caption medium uppercase>
                        <FormattedMessage id="special" />
                    </Paragraph>
                </HStack>
            </div>
        );
    }
    return (
        <HStack gap="micro">
            {isDiscountApplicable(dealerDiscountPercentage) && (
                <div
                    className={clsx(
                        styles.hostettlerProductDiscountPill,
                        styles.dealerDiscountPercentage
                    )}
                >
                    <HStack align="center" justify="center">
                        <Paragraph caption medium>
                            -{Math.round(dealerDiscountPercentage)}%
                        </Paragraph>
                    </HStack>
                </div>
            )}
            {isDiscountApplicable(
                customerPrice.additionalDiscountPercentage
            ) && (
                <div
                    className={clsx(
                        styles.hostettlerProductDiscountPill,
                        styles.preorderDiscountPercentage
                    )}
                >
                    <HStack align="center" justify="center">
                        <Paragraph
                            caption
                            medium
                            uppercase={!!appliedDiscountRule}
                        >
                            -{Math.round(additionalDiscountPercentage)}%
                        </Paragraph>
                    </HStack>
                </div>
            )}
        </HStack>
    );
};

export default memo(ProductDiscountsBoxView);
